module.exports = __webpack_public_path__ + "static/media/image_01.a30b83fc.jpg";